import moment from 'moment';
import currency from 'currency.js';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.tz.setDefault('America/New_York');

export default {
    formatMoney(value) {
        if (!value) return '';
        return currency(value).format();
    },
    formatPriceInCents(priceInCents) {
        if (!priceInCents || isNaN(priceInCents)) {
            return `$${priceInCents}`;
        }

        const price =
            typeof priceInCents === 'string'
                ? Number(priceInCents)
                : priceInCents;

        return currency(price / 100).format();
    },
    formatThousand(value) {
        if (!value) return '';

        if (typeof value == 'number') {
            value = Math.trunc(value);
        }
        const formattedValue = value
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        return formattedValue;
    },
    formatDate(value, inputTimeZone = 'UTC', outputTimeZone = 'UTC') {
        if (!value) return '';
        const inputDate = dayjs.tz(value, inputTimeZone);

        const outputDate = inputDate.tz(outputTimeZone);

        return outputDate.format('M/DD/YYYY');
    },
    formatShortDate(value) {
        if (!value) return '';
        return dayjs(value).format('MMMM D');
    },
    getDayWithOffset(utcOffset) {
        const time = dayjs().utcOffset(utcOffset);
        const day = time.format('dd');
        return day;
    },
    titleCase(value) {
        if (!value) return '';
        return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },
    splitCamelCase(inputString) {
        return inputString
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
            .trim();
    },
    ucWords(str) {
        if (typeof str === 'string' || str instanceof String) {
            if (str && str.length <= 3) {
                return str.toUpperCase();
            } else if (str)
                return str.replace(/^(.)|\s+(.)/g, function ($1) {
                    return $1.toUpperCase();
                });
        }
    },
    bonusTransferAsPercentage(baseRate, bonusRate) {
        const percentageValue = ((bonusRate - baseRate) / baseRate) * 100;
        return `${percentageValue.toFixed(0)}%`;
    },

    calculatePointsConversion(points, transferRate) {
        return Number(points) * transferRate;
    },

    calculateBonusDifference(points, bonusTransferRate, baseTransferRate) {
        const baseTransfer = this.calculatePointsConversion(
            points,
            baseTransferRate
        );
        const bonusTransfer = this.calculatePointsConversion(
            points,
            bonusTransferRate
        );

        return Math.trunc(bonusTransfer) - Math.trunc(baseTransfer);
    },
    getProgramBonusInfo(program, userPoints) {
        const bonus = program.bonusRateTo / program.bonusRateFrom;
        const base = program.transferRateTo / program.transferRateFrom;
        const bonusPoints = this.calculateBonusDifference(
            userPoints,
            bonus,
            base
        );

        if (!program.bonusExpiration) return null;

        return {
            bonusExpiration: program.bonusExpiration,
            bonusRate: `${program.bonusRateFrom}:${program.bonusRateTo}`,
            bonusPoints: bonusPoints,
            bonusPercentage: this.bonusTransferAsPercentage(base, bonus),
        };
    },
    formatAddress(propertyObj) {
        const { address_1, address_2, locality, region, postal_code, country } =
            propertyObj;
        return [address_1, address_2, locality, region, postal_code, country]
            .filter((part) => part && part.trim())
            .join(', ');
    },

    decodeHtmlEntities(str) {
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    },
    isValidDateRange(startDate, endDate) {
        let fromDate = startDate;
        let toDate = endDate;
        let fdate = new Date(fromDate);
        let tdate = new Date(toDate);
        if (fdate.valueOf() > tdate.valueOf() || !toDate) {
            return false;
        }
        return true;
    },
    haversineDistance(coords1, coords2) {
        const toRad = (x) => (x * Math.PI) / 180;
        const R = 6371;

        const dLat = toRad(coords2.lat - coords1.lat);
        const dLon = toRad(coords2.lng - coords1.lng);

        const lat1 = toRad(coords1.lat);
        const lat2 = toRad(coords2.lat);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) *
                Math.sin(dLon / 2) *
                Math.cos(lat1) *
                Math.cos(lat2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c; // Distance in kilometers
    },
    slugToSnakeCaseUppercase(slug) {
        slug = slug
            .toLowerCase()
            .replace(/-([a-z])/g, (match, char) => char.toUpperCase());

        return slug.charAt(0).toUpperCase() + slug.slice(1);
    },
};
